import { Analytics } from 'aws-amplify';

export const recordEvent = (options, logger) => {
  Analytics.record(options).catch(e => {
    logger.error(JSON.stringify(e));
    console.log(e);
  });
};
